import { LuIcon, Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { nameModelSortFn, type Project } from "@overmap-ai/common"
import { useSort, useTextFilter } from "@overmap-ai/hooks"
import { memo, type ReactElement } from "react"

import { projectFilterCallback } from "../../filtering/utils"
import { modelIconMapping } from "../../mappings/icons"
import {
	ProjectMultiSelectGroup,
	type ProjectMultiSelectGroupProps,
} from "../MenuMultiSelectGroups/ProjectMultiSelectGroup"

interface ProjectMultiSelectDropdownProps
	extends
		ProjectMultiSelectGroupProps,
		MenuVariantProps,
		MenuRootProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const ProjectMultiSelectDropdown = memo<ProjectMultiSelectDropdownProps>((props) => {
	const {
		children,
		disabled,
		projects,
		defaultValues,
		values,
		onValuesChange,
		size,
		variant,
		accentColor,
		radius,
		...rest
	} = props

	const sortedProjects = useSort(projects, nameModelSortFn)

	const [filteredProjects, filterValue, setFilterValue] = useTextFilter<Project>(
		sortedProjects,
		projectFilterCallback,
	)

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} variant={variant} accentColor={accentColor} radius={radius}>
				<Menu.InputRoot>
					<Menu.InputSlot>
						<LuIcon icon={modelIconMapping.search} />
					</Menu.InputSlot>
					<Menu.InputField placeholder="Search" value={filterValue} onValueChange={setFilterValue} />
				</Menu.InputRoot>
				{filteredProjects.length > 0 ? <Menu.Separator /> : null}
				<Menu.Scroll>
					{filteredProjects.length > 0 ? (
						<ProjectMultiSelectGroup
							projects={filteredProjects}
							defaultValues={defaultValues}
							values={values}
							onValuesChange={onValuesChange}
						/>
					) : null}
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
ProjectMultiSelectDropdown.displayName = "ProjectMultiSelectDropdown"
